import { createRouter, createWebHistory } from "vue-router";

// Public route components
import HomeView from "../views/HomeView.vue";

const routes = [
  // Public routes
  {
    path: "/",
    component: HomeView,
  },
  {
    path: "/about",
    component: () => import("../views/AboutView.vue"),
  },

  // 404 route
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top for specific routes if needed

    // If the user is using browser back/forward buttons
    if (savedPosition) {
      return savedPosition;
    }

    // Default behavior: scroll to top on navigation
    return {
      top: 0,
      left: 0,
      behavior: "smooth",
    };
  },
});

// Force scroll to top after each route navigation completes
router.afterEach(() => {
  window.scrollTo(0, 0);
});

// Export the original router so you can still use all the routing functions
export default router;
